module.exports = __webpack_public_path__ + "images/Alegreya-Regular_47439778717a494cad415e6e5cf8b790.ttf";